import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'
// Configuration
const GOOGLE_TAG_MANAGER_ID = 'GTM-5V2WHRG3'
const GA_MEASUREMENT_ID = 'G-FQKHRCTG8Y'
const GOOGLE_ADS_ID = 'AW-17739412957'
// Google Ads Conversion Labels
const CONVERSION_LABELS = {
  CONTACT_FORM_SUBMIT: 'YTFjCKLu-sEbEN3r54pC', // Your form submission conversion label
  PACKAGE_CLICK: 'YTFjCKLu-sEbEN3r54pC', // Use same or create separate conversion action in Google Ads
}
// Initialize analytics (this is supplementary to the direct GTM script)
export const analytics = Analytics({
  app: 'nura-health',
  plugins: [
    googleTagManager({
      containerId: GOOGLE_TAG_MANAGER_ID,
    }),
  ],
})
// Track page views (now handled by useAnalytics hook)
export const trackPageView = (path: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    })
  }
  // Send to dataLayer for GTM
  if (typeof window !== 'undefined' && (window as any).dataLayer) {
    ;(window as any).dataLayer.push({
      event: 'page_view',
      page_path: path,
    })
  }
}
// Track events
export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>,
) => {
  // Send to GA4
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, properties)
  }
  // Send to dataLayer for GTM
  if (typeof window !== 'undefined' && (window as any).dataLayer) {
    ;(window as any).dataLayer.push({
      event: eventName,
      ...properties,
    })
  }
}
// Track Google Ads conversions with proper format
export const trackConversion = (
  conversionType: keyof typeof CONVERSION_LABELS,
  value?: number,
  currency: string = 'EUR',
) => {
  const conversionLabel = CONVERSION_LABELS[conversionType]
  if (typeof window !== 'undefined' && window.gtag) {
    // Use Google Ads conversion format
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_ADS_ID}/${conversionLabel}`,
      value: value || 1.0,
      currency: currency,
    })
  }
  // Also push to dataLayer for GTM
  if (typeof window !== 'undefined' && (window as any).dataLayer) {
    ;(window as any).dataLayer.push({
      event: 'conversion',
      send_to: `${GOOGLE_ADS_ID}/${conversionLabel}`,
      value: value || 1.0,
      currency: currency,
      conversion_type: conversionType,
    })
  }
}
// Initialize Google Analytics after consent
export const initializeAnalytics = () => {
  trackPageView(window.location.pathname)
}
